import React from "react"
import { LAMP_MAP } from "../Utils/lamp"

interface TrafficLightWidgetProps {
  currentColor: string
  width?: number
}

const TrafficLightWidget: React.FC<TrafficLightWidgetProps> = ({
  currentColor,
  width = 184,
}) => (
  <img width={width} src={LAMP_MAP[currentColor].image} alt={currentColor} />
)

export default TrafficLightWidget
